export default "__VITE_PUBLIC_ASSET__2997f4db__"